import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ColumnChooserService,
  FilterService,
  GridModule,
  PageService,
  ResizeService,
  SortService,
} from '@syncfusion/ej2-angular-grids';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MyDatePickerModule } from 'mydatepicker';
import { VerificationsComponent } from './verifications.component';
import { VerificationsRoutingModule } from './verifications-routing.module';


@NgModule({
  declarations: [VerificationsComponent],
  imports: [
    CommonModule,
    MultiselectDropdownModule,
    NgxPaginationModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MyDatePickerModule,
   ReactiveFormsModule,
   FormsModule,
   GridModule,
   VerificationsRoutingModule
  ],
  exports:[
    VerificationsComponent,

  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService, ResizeService],
})
export class VerificationsModule { }
